var React = require('react');

function Chat (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m0 0h32v32h-32z","fill":"none","key":0}),React.createElement("path",{"d":"m16 .47c-8.84 0-16 5.69-16 12.71 0 5.44 4.3 10.08 10.35 11.89v6.46l5.65-5.65c8.84 0 16-5.69 16-12.7s-7.16-12.71-16-12.71zm-4 14a1.25 1.25 0 1 1 1.25-1.25 1.25 1.25 0 0 1 -1.25 1.24zm4 0a1.25 1.25 0 1 1 1.25-1.25 1.25 1.25 0 0 1 -1.25 1.24zm4 0a1.25 1.25 0 1 1 1.25-1.25 1.25 1.25 0 0 1 -1.25 1.24z","fill":"#f16e00","fillRule":"evenodd","className":"fill","key":1})]);
}

Chat.defaultProps = {"height":"32","width":"32","viewBox":"0 0 32 32"};

module.exports = Chat;

Chat.default = Chat;
